module.exports = __webpack_public_path__ + "img/profile-woman-2-min.7d69eca8.jpg";